import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Video } from "../../atoms/Video";
import { RowSeparator } from "../../atoms/RowSeparator";
import { fetchRSSFeed } from "../../utils/story";
import get from "lodash/get";
import PropTypes from "prop-types";
import Carousel from "../../atoms/Carousel";
import Headline from "../../atoms/Headline";
import { DfpComponent } from "../../ads/dfp-component";

import "./youtube-component.m.css";

export const YoutubeComponent = (collection) => {
  const [feedItems, setFeedItems] = useState([]);
  const [currentFeedVideo, setCurrentFeedVideo] = useState({});
  const [scrollNeeded, setScrollNeeded] = useState(false);
  const [error, setError] = useState(false);
  const mainVideoRef = useRef(null);

  const associatedMetadata = get(collection, ["associatedMetadata"], {});
  const playListId = associatedMetadata.playlist_id || null;
  const showRowAdBottomUnit = associatedMetadata.show_row_ad_unit_bottom || null;

  const sectionSlug = collection?.collection?.sectionSlug;
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );

  const getCurrentCard = (currentFeed) => {
    setCurrentFeedVideo(currentFeed);
    setScrollNeeded(true);
  };
  useEffect(() => {
    fetchRSSFeed("/youtube-feed/", playListId)
      .then((items) => {
        const alteredData = Array.from({ length: Math.ceil(items?.length / 4) }).map((_, i) =>
          items?.slice(i * 4, (i + 1) * 4)
        );
        setFeedItems(alteredData);
        setCurrentFeedVideo(items[0]);
      })
      .catch((err) => {
        setError(true);
        console.log(err.message);
      });
  }, [playListId]);

  useLayoutEffect(() => {
    if (mainVideoRef.current && scrollNeeded) {
      mainVideoRef.current.scrollIntoView({ behavior: "smooth" });
      setScrollNeeded(false);
    }
  }, [currentFeedVideo, scrollNeeded]);

  if (error) return null;
  if (!playListId) return null;

  return (
    <div className="container row-component" styleName="youtubeComp">
      <div styleName="mainVideo" ref={mainVideoRef}>
        <Video
          element={{
            "embed-url": `https://www.youtube.com/embed/${currentFeedVideo?.videoId}`,
            type: "youtube-video",
            url: `${currentFeedVideo?.videoUrl}&feature=youtu.be`,
          }}
        />
        <Headline
          styleName="title"
          headline={currentFeedVideo?.title ? currentFeedVideo?.title : feedItems?.[0]?.title}
          sectionSlug={sectionSlug}
        />
        <div styleName="divider"></div>
      </div>
      <Carousel feedItems={feedItems} getCurrentCard={getCurrentCard} sectionSlug={sectionSlug} />
      <RowSeparator />
      {showRowAdBottomUnit && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`youtube-component-row-bottom-ad`}
          path={showRowAdBottomUnit}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
};

YoutubeComponent.propTypes = {
  collection: PropTypes.shape({
    associatedMetadata: PropTypes.shape({
      playlist_id: PropTypes.string,
    }),
  }).isRequired,
};
